import store from "../store";

export default {
    data() {
        return {
            addingToCart: false,
        };
    },

    computed: {
        productUrl() {
            return route("products.show", this.product.slug);
        },

        hasAnyOption() {
            return this.product.options_count > 0;
        },

        hasNoOption() {
            return !this.hasAnyOption;
        },

        hasBaseImage() {
            return this.product.base_image.length !== 0;
        },

        baseImage() {
            if (this.hasBaseImage) {
                return this.product.base_image.path;
            }

            return `${window.FleetCart.baseUrl}/themes/storefront/public/images/image-placeholder.png`;
        },

        inWishlist() {
            return store.inWishlist(this.product.id);
        },

        inCompareList() {
            return store.inCompareList(this.product.id);
        },
    },

    methods: {
        syncWishlist() {
            store.syncWishlist(this.product.id);
        },

        syncCompareList() {
            store.syncCompareList(this.product.id);
        },

        addToCartCustom(product) {
            this.addingToCart = true;

            return new Promise((resolve, reject) => {
                let success = false;
                $.post(
                    route("cart.items.storeCustom"),
                    product
                ).then((cart) => {
                    store.updateCart(cart);
                    success = true;
                })
                    .catch((xhr) => {
                        this.$notify(xhr.responseJSON.message);
                    })
                    .always(() => {
                        this.addingToCart = false;
                        if (success) {
                            resolve();
                        } else {
                            reject();
                        }
                    });
            });
        },

        addToCartCustomSticker(files, mask_type, material, size, amount) {
            this.addingToCart = true;

            return new Promise((resolve, reject) => {
                let success = false;
                $.post(
                    route("cart.items.storeCustomFullForm"),
                    {
                        files: files,
                        mask: mask_type,
                        material: material,
                        size: size,
                        quantity: amount,
                    }
                ).then((cart) => {
                    store.updateCart(cart);

                    if (document.location.href !== route("cart.index")) {
                        $(".header-cart").trigger("click");
                    }
                    success = true;
                })
                    .catch((xhr) => {
                        this.$notify(xhr.responseJSON.message);
                    })
                    .always(() => {
                        this.addingToCart = false;
                        if (success) {
                            resolve();
                        } else {
                            reject();
                        }
                    });
            });
        },

        addToCartLabelPicker(files, labelId, sizeId) {
            this.addingToCart = true;

            return new Promise((resolve, reject) => {
                let success = false;
                $.post(
                    route("cart.items.storeCustomBulk"),
                    {
                        files: files,
                        label_type: labelId,
                        size: sizeId,
                    }
                ).then((cart) => {
                    store.updateCart(cart);

                    if (document.location.href !== route("cart.index")) {
                        $(".header-cart").trigger("click");
                    }
                    success = true;
                })
                    .catch((xhr) => {
                        this.$notify(xhr.responseJSON.message);
                    })
                    .always(() => {
                        this.addingToCart = false;
                        if (success) {
                            resolve();
                        } else {
                            reject();
                        }
                    });
            });
        },

        addToCart() {
            this.addingToCart = true;

            $.ajax({
                method: "POST",
                url: route("cart.items.store", {
                    product_id: this.product.id,
                    qty: 1,
                }),
            })
                .then((cart) => {
                    store.updateCart(cart);

                    if (document.location.href !== route("cart.index")) {
                        $(".header-cart").trigger("click");
                    }
                })
                .catch((xhr) => {
                    this.$notify(xhr.responseJSON.message);
                })
                .always(() => {
                    this.addingToCart = false;
                });
        },

        addToCartExisting(id)
        {
            this.addingToCart = true;

            $.ajax({
                method: "POST",
                url: route("cart.items.storeExisting", {
                    id: id,
                }),
            })
                .then((cart) => {
                    store.updateCart(cart);

                    if (document.location.href !== route("cart.index")) {
                        $(".header-cart").trigger("click");
                    }
                })
                .catch((xhr) => {
                    this.$notify(xhr.responseJSON.message);
                })
                .always(() => {
                    this.addingToCart = false;
                });
        },

        addSampleToCart() {
            this.addingToCart = true;

            $.ajax({
                method: "POST",
                url: route("cart.items.sample", {}),
            })
                .then((cart) => {
                    store.updateCart(cart);

                    if (document.location.href !== route("cart.index")) {
                        $(".header-cart").trigger("click");
                    }
                })
                .catch((xhr) => {
                    this.$notify(xhr.responseJSON.message);
                })
                .always(() => {
                    this.addingToCart = false;
                });
        }
    },
};
